export const replaceJSX = function (string, find, replace) {
  return string
    ?.split(find)
    .flatMap((item) => [item, replace])
    .slice(0, -1);
};
